import { css } from '@/styled-system/css';

export const tooltipContentStyles = css.raw({
  maxInlineSize: '360px',
  color: 'text.neutral',
  textStyle: 'body',
  backgroundColor: 'bg.elevated.mediumShadow',
  borderRadius: 'Tooltip',
  paddingInline: {
    base: 'tighter',
    lg: 'default',
  },
  paddingBlock: {
    base: 'tightest',
    lg: 'tighter',
  },
  filter: 'drop-shadow({shadows.Tooltip})',
  willChange: 'filter',
});

export const tooltipContentPositionerStyles = css.raw({
  zIndex: 'tooltip',
});
